import * as DomEventOptions from '../DomEventOptions/DomEventOptions.js'
import * as DomEventType from '../DomEventType/DomEventType.js'
import * as ViewletEditorImageEvents from './ViewletEditorImageEvents.js'

export const create = () => {
  const $Image = document.createElement('img')
  $Image.className = 'ViewletImage'
  $Image.draggable = false

  const $ImageWrapper = document.createElement('div')
  $ImageWrapper.className = 'ImageWrapper'
  $ImageWrapper.tabIndex = 0
  $ImageWrapper.append($Image)

  const $Viewlet = document.createElement('div')
  $Viewlet.className = 'Viewlet EditorImage'
  $Viewlet.append($ImageWrapper)

  return {
    $Viewlet,
    $Image,
    $ImageWrapper,
  }
}

export const attachEvents = (state) => {
  const { $Image, $ImageWrapper, $Viewlet } = state
  $Image.onerror = ViewletEditorImageEvents.handleError

  $ImageWrapper.onfocus = ViewletEditorImageEvents.handleFocus

  $Viewlet.onpointerdown = ViewletEditorImageEvents.handlePointerDown
  $Viewlet.onpointerup = ViewletEditorImageEvents.handlePointerUp
  $Viewlet.oncontextmenu = ViewletEditorImageEvents.handleContextMenu
  $Viewlet.addEventListener(DomEventType.Wheel, ViewletEditorImageEvents.handleWheel, DomEventOptions.Passive)
}

export const setTransform = (state, transform) => {
  const { $ImageWrapper } = state
  $ImageWrapper.style.transform = transform
}

export const setSrc = (state, src) => {
  const { $Image } = state
  $Image.src = src
}

export const setDragging = (state, isDragging) => {
  const { $Viewlet } = state
  $Viewlet.classList.toggle('Dragging', isDragging)
}

export const dispose = (state) => {}

export const setError = (state, message) => {
  const { $Viewlet } = state
  const $Error = document.createElement('div')
  $Error.className = 'ViewletError'
  $Error.textContent = message
  $Viewlet.replaceChildren($Error)
}
